<template>
  <div>
    <v-data-table
            :headers="protocolsHeaders"
            :items="list"
            :items-per-page="15"
            class="general-table"
            :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
          >
            <template v-slot:header.created_at="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-CREATED_AT"></lang>
            </template>

            <template v-slot:header.request_ip="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-IP_ADDRESS"></lang>
            </template>

            <template v-slot:header.type="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-TYPE"></lang>
            </template>

            <template v-slot:header.status_code="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-STATUS_CODE"></lang>
            </template>

            <template v-slot:header.error_code="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-ERROR_CODE"></lang>
            </template>

            <template v-slot:header.processing_ms="{ header }">
              <lang t="ITEM-PROTOCOL-TBL-HEADER-PROCESS_MS"></lang>
            </template>

            <template v-slot:header.show_body="{ header }"> </template>


            <template v-slot:item.created_at="{ item }">
              {{ dateFormat(item.created_at) }}
            </template>

         
            <template v-slot:item.show_body="{ item }">
              <v-btn text @click="showProtocolBody(item.body)">
                <lang t="BTN-SHOW_PROTOCOL_BODY"></lang>
              </v-btn>
            </template>
          </v-data-table>
 
          <v-dialog v-model="dialog.show" :max-width="dialog.width">
    
      <v-card>
        <v-card-title>
          <span class="headline"><lang :t="dialog.title"></lang></span>
        </v-card-title>
        <!-- PROTOCOL -->
        <template v-if="dialog.type == 'PROTOCOL'">
          <v-card-text>
            <pre>{{ formatXml(protocolSelected) }}</pre>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal" :disabled="dialog.isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'TabValueChain',
  props: {
    warehouseId: {
      type: Number,
      required: true,
    },
  },
  components:{},
  data: () => ({
    isLoading: true,
    search: "",

    protocolSelected: null,

    protocolsHeaders: [
      {
        text: "CREATED",
        value: "created_at",
        sortable: false,
      },
      {
        text: "IP",
        value: "request_ip",
        sortable: false,
      },
      {
        text: "TYPE",
        value: "type",
        sortable: false,
      },
      {
        text: "STATUS_CODE",
        value: "status_code",
        sortable: false,
      },
      {
        text: "ERROR_CODE",
        value: "error_code",
        sortable: false,
      },
      {
        text: "PROCESS_MS",
        value: "processing_ms",
        sortable: false,
      },
      {
        text: "SHOW_BODY",
        value: "show_body",
        sortable: false,
      },
    ],
    dialog: {
      show: false,
      isSaving: false,
      title: null,
      type: null,
      width: "640px",
    },


    list: [],
  }),

  computed: {},

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    showProtocolBody(protocol) {
      this.protocolSelected = protocol;
      this.dialog.type = "PROTOCOL";
      this.dialog.title = "ARTICLE-PROTOCOL-BODY";
      this.dialog.width = "85%";
      this.dialog.show = true;
    },

    formatXml(xml) {
      var formatted = "";
      var reg = /(>)(<)(\/*)/g;
      xml = xml.replace(reg, "$1\r\n$2$3");
      var pad = 0;

      xml.split("\r\n").forEach((node, index) => {
        var indent = 0;
        if (node.match(/.+<\/\w[^>]*>$/)) {
          indent = 0;
        } else if (node.match(/^<\/\w/)) {
          if (pad != 0) {
            pad -= 1;
          }
        } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
          indent = 1;
        } else {
          indent = 0;
        }

        var padding = "";
        for (var i = 0; i < pad; i++) {
          padding += "  ";
        }

        formatted += padding + node + "\r\n";
        pad += indent;
      });
      return formatted;
    },

    initialize() {
      this.axios.get(`warehouses/${this.warehouseId}/wmsProtocol`).then((res) => {
        this.list = res.data;
        this.isLoading = false;
      });
    },
  },
};
</script>
<style lang="scss">

</style>
